export default "__VITE_ASSET__BJT2bmUV__"